import { Box, CssBaseline, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import AppTheme from "../../../theme/AppTheme";
import { dataGridCustomizations } from "../../../theme/customizations";
import ComingSoon from "../../ComingSoonPage";

const EditCampaign = (props: { disableCustomTheme?: boolean }) => {
  const { campaignId } = useParams();
  const xThemeComponents = {
    ...dataGridCustomizations,
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Edit Campaign {campaignId ? `#${campaignId}` : ""}
        </Typography>
        <ComingSoon />
      </Box>
    </AppTheme>
  );
};

export default EditCampaign;

